<div>
    <p-table [value]="receitas" [lazy]="true" (onLazyLoad)="loadReceitas($event)" [paginator]="true" [rows]="rows" [first]="first" [totalRecords]="totalRecords" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [rowsPerPageOptions]="[20, 50, 100]" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"  [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true" [tableStyle]="{'font-size':'.9rem', 'font-weight':'400', 'border-spacing':'0 0 !important', 'border-colapse': 'separate'}"  #dt>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="empresa">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
            <th pSortableColumn="filial">Filial <p-sortIcon field="filial"></p-sortIcon></th>
            <th pSortableColumn="dataReferencia">Data Referência <p-sortIcon field="dataReferencia"></p-sortIcon></th>
            <th pSortableColumn="material">Material <p-sortIcon field="material"></p-sortIcon></th>
            <th pSortableColumn="descricaoMaterial">Descrição Material <p-sortIcon field="descricaoMaterial"></p-sortIcon></th>
            <th pSortableColumn="contaContabil">Conta Contábil <p-sortIcon field="contaContabil"></p-sortIcon></th>
            <th pSortableColumn="valorTotal">Valor Total <p-sortIcon field="valorTotal"></p-sortIcon></th>
            <th pSortableColumn="dataRecebimento">Data Recebido <p-sortIcon field="dataRecebimento"></p-sortIcon></th>
            <th pSortableColumn="statusIntegracao">Status Integração <p-sortIcon field="statusIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataIntegracao">Data Integração <p-sortIcon field="dataIntegracao"></p-sortIcon></th>
            <th pSortableColumn="mensagemIntegracao">Mensagem Integração <p-sortIcon field="mensagemIntegracao"></p-sortIcon></th>
            <th pSortableColumn="dataUltimaAtualizacao">Data Última Atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-receita>
          <tr>
            <td>{{ receita.empresa }}</td>
            <td>{{ receita.filial }}</td>
            <td>{{ receita.dataReferencia }}</td>
            <td>{{ receita.material }}</td>
            <td>{{ receita.descricaoMaterial }}</td>
            <td>{{ receita.contaContabil }}</td>
            <td>{{ receita.valorTotal.toLocaleString("pt-BR") }}</td>
            <td>{{ receita.dataRecebimento }}</td>
            <td><app-tag-status [status]="receita.statusIntegracao"></app-tag-status></td>
            <td>{{ receita.dataIntegracao }}</td>
            <td>{{ receita.mensagemIntegracao }}</td>
            <td>{{ receita.dataUltimaAtualizacao }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <td colspan="21">Nenhum registro encontrado</td>
      </ng-template>
      </p-table>
</div>
